// extracted by mini-css-extract-plugin
export var centered = "Cover-module--centered--789fd";
export var cover = "Cover-module--cover--c6943";